import { render, staticRenderFns } from "./poi-card.vue?vue&type=template&id=15b6acb7&scoped=true&"
import script from "./poi-card.vue?vue&type=script&lang=ts&"
export * from "./poi-card.vue?vue&type=script&lang=ts&"
import style0 from "./poi-card.vue?vue&type=style&index=0&id=15b6acb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6acb7",
  null
  
)

export default component.exports